<!-- DonateForm.vue -->
<template>
	<form @submit.prevent="submitForm" class="uk-form-stacked">
		<input type="hidden" :name="csrfName" :value="csrfToken">
		<input type="hidden" name="action" value="mollie-payments/payment/donate">
		<input type="hidden" name="redirect" :value="redirect">
		<input type="hidden" name="form" :value="formHandle">

		<div class="uk-margin">
			<label class="uk-form-label" for="amount">Bedrag</label>
			<div class="uk-form-controls">
				<input class="uk-input" type="text" id="amount" v-model="amount" name="amount" placeholder="Bedrag in euro's">
			</div>
		</div>
		<div class="uk-margin">
			<label class="uk-form-label" for="email">Emailadres</label>
			<div class="uk-form-controls">
				<input class="uk-input" type="email" id="email" v-model="email" name="email">
			</div>
		</div>
		<div class="uk-margin">
			<label class="uk-form-label" for="firstName">Voornaam</label>
			<div class="uk-form-controls">
				<input class="uk-input" type="text" id="firstName" v-model="firstName" name="fields[firstName]">
			</div>
		</div>
		<div class="uk-margin">
			<label class="uk-form-label" for="lastName">Achternaam</label>
			<div class="uk-form-controls">
				<input class="uk-input" type="text" id="lastName" v-model="lastName" name="fields[lastName]">
			</div>
		</div>

		<div class="uk-margin">
			<input type="submit" class="uk-button uk-button-primary" value="Doneren">
		</div>
		<loading-indicator v-if="loading" />
	</form>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
	name: 'DonateForm',
	components: {
		LoadingIndicator
	},
	props: {
		redirect: {
			type: String,
			required: true
		},
		formHandle: {
			type: String,
			required: true
		},
		email: {
			type: String,
			default: ''
		},
		firstName: {
			type: String,
			default: ''
		},
		lastName: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			loading: false,
			amount: '',
			email: this.email,
			firstName: this.firstName,
			lastName: this.lastName
		}
	},
	computed: {
		csrfName () {
			return window.csrfTokenName
		},
		csrfToken () {
			return window.csrfTokenValue
		},
	},	
	methods: {
		async submitForm() {
			this.loading = true;
			
			try {
				await axios.post('/', this.getFormData());
				window.location.href = this.redirect;
			} catch (error) {
				console.error('Payment failed', error);
			} finally {
				this.loading = false;
			}
		},
		getFormData() {
			const formData = new FormData();
			
			formData.append(this.csrfName, this.csrfToken);
			formData.append('action', 'mollie-payments/payment/donate');
			formData.append('redirect', this.redirect);
			formData.append('amount', this.amount);
			formData.append('form', this.formHandle);
			formData.append('email', this.email);
			formData.append('fields[firstName]', this.firstName);
			formData.append('fields[lastName]', this.lastName);
			
			return formData;
		}
	}
}
</script>

<style scoped>
</style>
